// Single source for the feature's paths. ASSESSMENT_PATH is mirrored by the
// backend's CANDIDATE_PATH (app/services/hiring/assessments/invites.py) — the
// emailed link is `${FRONTEND_URL}/bulk-hiring/assessment#token=…`.
export const ASSESSMENT_PATH = '/bulk-hiring/assessment';
// Trailing slashes are ignored. The page
// renders outside the app shell (no Clerk/UserProvider), so the predicate must
// agree between index.js, App.js and public/index.html's analytics guard.
export const isBulkHiringAssessmentPath = (pathname) =>
  pathname.replace(/\/+$/, '') === ASSESSMENT_PATH;
